import React, { useState } from "react";
import he from "he";

interface Props {
	title: string;
	value: string;
	className?: string;
}

const Title: React.FC<Props> = ({ title = "h1", className = "", value = "" }) => {
	if (title === "h1") {
		return <h1 className={className + " _h1"} dangerouslySetInnerHTML={{ __html: he.decode(value) }}></h1>;
	}
	if (title === "h2") {
		return <h2 className={className + " _h2"} dangerouslySetInnerHTML={{ __html: he.decode(value) }}></h2>;
	}
	if (title === "h3") {
		return <h3 className={className + " _h3"} dangerouslySetInnerHTML={{ __html: he.decode(value) }}></h3>;
	}
	if (title === "h4") {
		return <h4 className={className + " _h4"} dangerouslySetInnerHTML={{ __html: he.decode(value) }}></h4>;
	}
	if (title === "h5") {
		return <h5 className={className + " _h5"} dangerouslySetInnerHTML={{ __html: he.decode(value) }}></h5>;
	}
	if (title === "h6") {
		return <h6 className={className + " _h6"} dangerouslySetInnerHTML={{ __html: he.decode(value) }}></h6>;
	}

	return <></>;
};

export default Title;
